angular.module('jv.tracking.jobBoards.listCtrl', [])
    .controller('jobBoardsListCtrl', ['$scope', 'jobBoards','jobBoardService','$rootScope','$routeParams','jvTrackingMessages',
        function ($scope, jobBoards, jobBoardService, $rootScope, $routeParams, jvTrackingMessages) {
            $scope.jobBoards = jobBoards;
            $rootScope.flags = $rootScope.flags || {};
            $rootScope.flags.loading = false;

            if($routeParams.message){
                if($routeParams.error){
                    $rootScope.error = jvTrackingMessages[$routeParams.message.toUpperCase()];
                }else{
                    $rootScope.notice = jvTrackingMessages[$routeParams.message.toUpperCase()];
                }
            }

            $scope.deleteJobBoard = function(jobBoardName){
                if(confirm(jvTrackingMessages['CONFIRM'])){
                    jobBoardService.deleteJobBoard(jobBoardName, function(response, code){
                        if(code === 200){
                            $rootScope.notice = jvTrackingMessages['DELETED'];
                            //remove the deleted jobBoard from list
                            angular.forEach($scope.jobBoards, function(jobBoard, index){
                                if(jobBoard['name']===jobBoardName){
                                    $scope.jobBoards.splice(index,1);
                                }
                            });
                            $rootScope.flags.loading = false;
                        }
                    }, function(){
                        $rootScope.error = jvTrackingMessages['OPSERROR'];
                        $rootScope.flags.loading = false;
                    });
                }
            };
        }
    ]);